var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 6.60714C19.7947 6.60714 20.0357 6.84821 20.0357 7.14286V8.21429H3.96432V7.14286C3.96432 6.84821 4.20539 6.60714 4.50003 6.60714H19.5ZM20.0357 11.4286V17.8571C20.0357 18.1518 19.7947 18.3929 19.5 18.3929H4.50003C4.20539 18.3929 3.96432 18.1518 3.96432 17.8571V11.4286H20.0357ZM4.50003 5C3.31812 5 2.35718 5.96094 2.35718 7.14286V17.8571C2.35718 19.0391 3.31812 20 4.50003 20H19.5C20.682 20 21.6429 19.0391 21.6429 17.8571V7.14286C21.6429 5.96094 20.682 5 19.5 5H4.50003ZM6.37503 15.1786C5.92972 15.1786 5.57146 15.5368 5.57146 15.9821C5.57146 16.4275 5.92972 16.7857 6.37503 16.7857H7.98218C8.42749 16.7857 8.78575 16.4275 8.78575 15.9821C8.78575 15.5368 8.42749 15.1786 7.98218 15.1786H6.37503ZM10.6607 15.1786C10.2154 15.1786 9.85718 15.5368 9.85718 15.9821C9.85718 16.4275 10.2154 16.7857 10.6607 16.7857H14.4107C14.8561 16.7857 15.2143 16.4275 15.2143 15.9821C15.2143 15.5368 14.8561 15.1786 14.4107 15.1786H10.6607Z",
    fill: "#040404"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/paymentIcon.2dab872060653f73e80633b2cd5c447d.svg";
export { ForwardRef as ReactComponent };